// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../services/authService';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = authService.isAuthenticated();
  
  if (!isAuthenticated) {
    // Nicht authentifizierte Benutzer zur Login-Seite umleiten
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

export default ProtectedRoute;